import React from 'react';
import './TrainingTimeFields.css';
export default function TrainingTimeFields({ minutes, seconds, onMinutes, onSeconds, prefix = 'Tempo' }) {
  return <div className="training-time-fields">
    <label>{prefix} — minutos<input aria-label={`${prefix} — minutos`} type="number" min="0" max="1440" step="1" placeholder="0" value={minutes} onChange={e => onMinutes(e.target.value)} /></label>
    <label>Segundos<input aria-label={`${prefix} — segundos`} type="number" min="0" max="59" step="1" placeholder="0" value={seconds} onChange={e => onSeconds(e.target.value)} /></label>
  </div>;
}
